(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.inlineLoadingGif = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var nxThemeOff = document.documentElement && document.documentElement.getAttribute('data-nx-theme') === 'off';
  var isDarkMode = !nxThemeOff && window.matchMedia('(prefers-color-scheme: dark)').matches;
  // 20kb版本——
  var inlineLoadingGif = exports.inlineLoadingGif = isDarkMode ? 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/95d2a7f0-246d-11ee-9b0e-4124cbfa4a8c.gif' : 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/166a7ed0-246c-11ee-b043-839c63d126b3.gif';
  // 35kb版本——
  var inlineLoadingGifS = exports.inlineLoadingGifS = isDarkMode ? 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/cd49c370-246e-11ee-8314-c51481d7a20d.gif' : 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/cd4aadd0-246e-11ee-8b2d-6fcde82c71b3.gif';

  var inlineLoadingGifBlue = exports.inlineLoadingGifBlue = isDarkMode ? 'https://gaia-xy.vivo.com.cn/wallet/common/07b82580-00a4-11ef-aac1-efac7c313b76.gif' : 'https://gaia-xy.vivo.com.cn/wallet/common/6ca1dca0-fe2b-11ee-93e3-ff19503eda3b.gif';
});